import React from 'react';
import { Mail, Phone, ShieldCheck, Clock, MapPin } from 'lucide-react';
import { contactContent, siteConfig } from '../data';
import ContactForm from '../components/ContactForm';
import ScrollReveal from '../components/ScrollReveal';
import SEO from '../components/SEO';

export default function Kontakt() {
  const { title, text, info } = contactContent;

  return (
    <div className="bg-slate-50/50 py-16 sm:py-24">
      <SEO 
        title="Kontakt SECoaching | Book en uforpligtende samtale"
        description="Har du spørgsmål eller ønsker du at booke en samtale om et mindsetforløb? Kontakt Steffen fra SECoaching i dag på tlf. 41174266 eller send en besked."
      />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Grid Layout */}
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 items-start">
          {/* Contact Info Column */}
          <ScrollReveal direction="up" duration={800} className="lg:col-span-5 space-y-8">
            <div className="space-y-6">
              <h3 className="text-xl font-bold text-blue-950">Direkte kontakt</h3>
              <p className="text-sm text-slate-500">
                Du er altid velkommen til at ringe, sende en SMS eller skrive en e-mail. Jeg svarer så hurtigt som muligt.
              </p>

              <div className="divide-y divide-slate-200">
                {/* Mail */}
                <div className="flex items-center gap-4 py-5 first:pt-0">
                  <div className="flex shrink-0 items-center justify-center">
                    <Mail className="h-8 w-8 text-slate-900" />
                  </div>
                  <div>
                    <a href={`mailto:${info.email}`} className="text-base font-bold text-blue-950 hover:text-sky-500 transition-colors">
                      {info.email}
                    </a>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex items-center gap-4 py-5">
                  <div className="flex shrink-0 items-center justify-center">
                    <Phone className="h-8 w-8 text-slate-900" />
                  </div>
                  <div>
                    <a href={`tel:${info.phone}`} className="text-base font-bold text-blue-950 hover:text-sky-500 transition-colors">
                      {siteConfig.phoneFormatted}
                    </a>
                  </div>
                </div>

                {/* Location */}
                <div className="flex items-center gap-4 py-5 last:pb-0">
                  <div className="flex shrink-0 items-center justify-center">
                    <MapPin className="h-8 w-8 text-slate-900" />
                  </div>
                  <div>
                    <span className="text-sm font-medium text-slate-700">
                      Fleksible løsninger: Online via video eller fysisk efter aftale.
                    </span>
                  </div>
                </div>
              </div>

              {/* CVR & Security */}
              <div className="border-t border-slate-200 pt-6 space-y-3">
                <div className="flex items-center gap-2.5 text-xs text-slate-500">
                  <ShieldCheck className="h-5 w-5 text-slate-900" />
                  <span>Registreret virksomhed · CVR: {info.cvr}</span>
                </div>
                <div className="flex items-center gap-2.5 text-xs text-slate-500">
                  <Clock className="h-5 w-5 text-slate-900" />
                  <span>Svartid: Typisk inden for 24 timer</span>
                </div>
              </div>
            </div>

            {/* FAQ / Help Box */}
            <div className="space-y-2 pt-4">
              <h4 className="font-bold text-blue-950 text-sm uppercase tracking-wider">Uforpligtende samtale</h4>
              <p className="text-sm text-slate-600 leading-relaxed">
                Den første samtale er altid 100% uforpligtende. Her finder vi ud af, om der er et godt match, og hvordan et forløb kan skrues sammen for dig.
              </p>
            </div>
          </ScrollReveal>

          {/* Contact Form Column */}
          <ScrollReveal direction="up" duration={900} className="lg:col-span-7">
            <ContactForm />
          </ScrollReveal>
        </div>
      </div>
    </div>
  );
}
